<div class="modal__content modal__content-center modal__content-loader" :class="{'modal__content-vip': camStore.type === 'vipchat'}">
    <h3>{{ $t('modals.loader.title') }}</h3>
    <img class="loader"  :src="getStaticImages('loading', 'png')" />
    <div class="form__group nopad">
        <p class="text" v-html="$t('modals.loader.desc')" v-if="camStore.type != 'vipchat'"></p>
        <p class="text" v-html="$t('modals.loader.desc-vip', {credits: $filters.niceCredits(performer.price.vipvideoCredits)})" v-if="performer && camStore.type === 'vipchat'"></p>
    </div>
    <button class="btn btn btn-full" @click="cancel()">{{ $t('modals.loader.cancel') }}</button>
</div>
